"use client"

import PillButton from '@/components/Atoms/Buttons/PillButton';

import React, { useState } from 'react';
import SpecializationChildCard from './SpecializationChildCard';
// import Button_1 from '../Atoms/Buttons/Button_1';
// import Link from 'next/link';
const SpecializationsParentCard = ({ lang, showIntro}) => {

  const [selectedSpecializationId, setSelectedSpecializationId] = useState(1)
  const [selectedSpecializationColors, setSelectedSpecializationColors] = useState('blue')
  const [selectedSpecializationCategoryName, setSelectedSpecializationCategoryName] = useState(lang === 'fr' ? 'Développement et Ingénierie Logicielle' : 'Software Development & Engineering')

  const scrollLeft=()=> {
    document.getElementById('pillButtonContainer').scrollBy({
      left: -175, // Scroll left by 200px
      behavior: 'smooth',
    });
  }

  const scrollRight = () => {
    document.getElementById('pillButtonContainer').scrollBy({
      left: 175, // Scroll left by 200px
      behavior: 'smooth',
    });
  }

  const handlePillButtonCallback = cb => {
    if (selectedSpecializationId > cb.selectedCategoryId) { 
      scrollLeft()
    }
    else {
      scrollRight()
    }
    setSelectedSpecializationId(cb.selectedCategoryId)
    setSelectedSpecializationColors(cb.selectedCategoryColors)
    setSelectedSpecializationCategoryName(cb.selectedCategoryName)
  }

  const backgroundColorVariants = {
    gray: 'bg-gray-100 dark:bg-gray-600',
    white: 'bg-white dark:bg-gray-900',
    blue: 'bg-blue-600 dark:bg-blue-500',
    indigo: 'bg-indigo-600 dark:bg-indigo-500',
    violet: 'bg-violet-600 dark:bg-violet-600',
    purple: 'bg-purple-600 dark:bg-purple-500',
    fuchsia: 'bg-fuchsia-600 dark:bg-fuchsia-600',
    pink: 'bg-pink-600 dark:bg-pink-600',

  }

  const borderColorVariants = {
     amber: 'border-amber-500',
     green: 'border-green-500',
     gray: 'border-gray-500 dark:border-gray-500',
    white: 'bg-white dark:bg-gray-900',
    blue: 'border-blue-500 dark:border-blue-400',
    indigo: 'border-indigo-500 dark:border-indigo-600',
     violet: 'border-violet-500 dark:border-violet-600',
     purple: 'border-purple-500 dark:border-purple-600',
     fuchsia: 'border-fuchsia-500 dark:border-fuchsia-600',
     pink: 'border-pink-500 dark:border-pink-600',
  }

  const textColorVariants = { 
    gray: 'text-gray-500 dark:text-gray-500',
    white: 'text-white',
    blue: 'text-blue-600',
    indigo: 'text-indigo-600',
     violet: 'text-violet-600',
     purple: 'text-purple-600',
     fuchsia: 'text-fuchsia-600',
     pink: 'text-pink-600',
  }

  let specializations = [
    {category_id: 1, caption_fr: 'Ingénieur Logiciel', caption_en: 'Software Engineer'},
    {category_id: 1, caption_fr: 'Développeur FrontEnd', caption_en: 'FrontEnd Developer'},
    {category_id: 1, caption_fr: 'Développeur BackEnd', caption_en: 'BackEnd Developer'},
    {category_id: 1, caption_fr: 'Développeur FullStack', caption_en: 'FullStack Developer'},
    {category_id: 1, caption_fr: 'Développeur Mobile', caption_en: 'Mobile Developer'},
    {category_id: 1, caption_fr: 'Ingénieur DevOps', caption_en: 'DevOps Engineer'},
    {category_id: 1, caption_fr: 'Architecte Logiciel', caption_en: 'Software Architect'},
    {category_id: 1, caption_fr: 'Ingénieur en Automatisation', caption_en: 'Automation Engineer'},

    {category_id: 2, caption_fr: 'Administrateur système', caption_en: 'System Administrator'},
    {category_id: 2, caption_fr: 'Administrateur réseau', caption_en: 'Network Administrator'},
    {category_id: 2, caption_fr: 'Spécialiste au Support Applicatif', caption_en: 'Application Support Specialist'},
    {category_id: 2, caption_fr: 'Ingénieur cloud', caption_en: 'Cloud Engineer'},
    {category_id: 2, caption_fr: 'Administrateur de bases de données (DBA)', caption_en: 'Database Administrator (DBA)'},
    {category_id: 2, caption_fr: 'Spécialiste du support informatique', caption_en: 'IT Support Specialist'},
    {category_id: 2, caption_fr: 'Technicien de help desk', caption_en: 'Help Desk Technician'},
    

    {category_id: 3, caption_fr: "Analyste d'Affaires", caption_en: "Business Analyst"},
    {category_id: 3, caption_fr: "Analyste Systèmes", caption_en: "Systems Analyst"},
    {category_id: 3, caption_fr: "Spécialiste ERP", caption_en: "ERP Specialist"},
    {category_id: 3, caption_fr: "Spécialiste CRP", caption_en: "CRM Specialist"},
    {category_id: 3, caption_fr: "Chef de Produit", caption_en: "Product Manager"},
    {category_id: 3, caption_fr: "Architecte de Solutions", caption_en: "Solutions Architect"},
    {category_id: 3, caption_fr: "Analyste des Systèmes d'Affaires",caption_en: "Business Systems Analyst"},
    {category_id: 3, caption_fr: "Chef de Projet TI",caption_en: "IT Project Manager"},

    {category_id: 4, caption_fr: "Scientifique des Données", caption_en: "Data Scientist"},
    {category_id: 4, caption_fr: "Ingénieur Des Données", caption_en: "Data Engineer"},
    {category_id: 4, caption_fr: "Analyste De Données", caption_en: "Data Analyst"},
    {category_id: 4, caption_fr: "Architecte De Données", caption_en: "Data Architect"},
    {category_id: 4, caption_fr: "Développeur en Intelligence d'Affaires (BI)", caption_en: "Business Intelligence (BI) Developer"},
    {category_id: 4, caption_fr: "Ingénieur En Big Data", caption_en: "Big Data Engineer"},
    {category_id: 4, caption_fr: "Spécialiste En IA", caption_en: "AI Specialist"},
    {category_id: 4, caption_fr: "Ingénieur en Apprentissage Automatique", caption_en: "Machine Learning Engineer"},


    {category_id: 5, caption_fr: "Architecte de Solutions Cloud", caption_en: "Cloud Solutions Architect"},
    {category_id: 5, caption_fr: "Administrateur Cloud", caption_en: "Cloud Administrator"},
    {category_id: 5, caption_fr: "Ingénieur de Sécurité Cloud", caption_en: "Cloud Security Engineer"},
    {category_id: 5, caption_fr: "Ingénieur DevOps Cloud", caption_en: "Cloud DevOps Engineer"},
    {category_id: 5, caption_fr: "Consultant Cloud", caption_en: "Cloud Consultant"},
    {category_id: 5, caption_fr: "Ingénieur en Virtualisation", caption_en: "Virtualization Engineer"},
    {category_id: 5, caption_fr: "Ingénieur en Infrastructure Cloud", caption_en: "Cloud Infrastructure Engineer"},
    {category_id: 5, caption_fr: "Ingénieur en Plateforme Cloud", caption_en: "Cloud Platform Engineer"},
    {category_id: 5, caption_fr: "Ingénieur en Fiabilité de Site (SRE)", caption_en: "Site Reliability Engineer (SRE)"},
    {category_id: 5, caption_fr: "Spécialiste en Migration Cloud", caption_en: "Cloud Migration Specialist"},


    {category_id: 6, caption_fr: "Analyste en Sécurité", caption_en: "Security Analyst"},
    {category_id: 6, caption_fr: "Spécialiste en Cybersécurité", caption_en: "Cybersecurity Specialist"},
    // {category_id: 6, caption_fr: "Hacker Éthique", caption_en: "Ethical Hacker"},
    {category_id: 6, caption_fr: "Ingénieur en Sécurité", caption_en: "Security Engineer"},
    {category_id: 6, caption_fr: "Testeur de Pénétration", caption_en: "Penetration Tester"},
    {category_id: 6, caption_fr: "Analyste Des Risques", caption_en: "Risk Analyst"},
  ]

  const specializationIntros = {
    1 : {
      content_fr: "Que vous ayez besoin d'ingénieurs hautement qualifiés pour tester et déployer des logiciels ou de développeurs pour créer des applications de l'interface utilisateur au côté serveur, Talentive est là pour vous aider à trouver les bons talents au Canada. Le poste en développement et ingénierie logicielle sont notre plus grande spécialité chez Talentive !",
      content_en: "Whether you need highly skilled engineers to test and deploy software or developers to build applications from the user interface to the server-side, Talentive is here to help you find the right talent in Canada. Software Development & Engineering are our bread and butter at Talentive!"
    },
     2 : {
      content_fr: "Que vous ayez besoin de professionnels pour gérer vos systèmes informatiques ou d'experts pour optimiser votre infrastructure, Talentive est là pour vous aider à trouver les professionels dont il vous faut. Nous excellons particulièrement dans les postes en administration systmème et support !",
      content_en: "Whether you need professionals to manage your IT systems or experts to optimize your infrastructure, Talentive is here to help you find the right professionals. We excel in system administration and support roles!"
    },
    3: {
      content_fr: "Nous comprenons que l'analyse des affaires et des systèmes est essentielle pour la réussite de votre entreprise. Que vous ayez besoin d'analystes pour transformer des données en informations exploitables ou de gestionnaires de projet pour diriger vos initiatives, Talentive est prêt à vous aider à trouver ces spécialistes. L'analyse des affaires et des systèmes est un domaine dans lequel nous excellons !",
      content_en: "We understand that business and systems analysis is essential for your company's success. Whether you need analysts to turn data into actionable insights or project managers to lead your initiatives, Talentive is ready to help you find specialists. Business & Systems Analysis is a field in which we excel!"
    },
    4: {
      content_fr: "Dans un monde où les données sont essentielles, nous vous aidons à identifier des talents capables de transformer des informations brutes en connaissances exploitables. Que vous ayez besoin de scientifiques de données, d'analystes ou d'ingénieurs en apprentissage automatique, Talentive est là pour vous connecter avec les meilleurs professionnels. Les données et l'analyse sont notre passion chez Talentive !",
      content_en: "In a world where data is essential, we help you identify talents capable of transforming raw information into actionable insights. Whether you need data scientists, analysts, or machine learning engineers, Talentive is here to connect you with the best professionals. Data & Analytics is our passion at Talentive!"
    },
    5 : {
      content_fr: "Avec l'évolution rapide des technologies cloud, nous vous aidons à trouver des experts en cloud computing et en virtualisation pour faire évoluer votre infrastructure. Que vous ayez besoin d'architectes de solutions cloud, d'ingénieurs de sécurité cloud ou d'administrateurs, Talentive est prêt à vous aider à bâtir une équipe solide. Le cloud et la virtualisation sont des domaines clés pour nous chez Talentive !",
      content_en: "With the rapid evolution of cloud technologies, we help you find experts in cloud computing and virtualization to scale your infrastructure. Whether you need cloud solutions architects, cloud security engineers, or administrators, Talentive is ready to help you build a strong team. Cloud & Virtualization are key areas for us at Talentive!"
    },
    6 : { 
      content_fr: "La cybersécurité est plus importante que jamais dans le paysage numérique actuel. Nous vous aidons à recruter des spécialistes capables de protéger vos systèmes et vos données. Que vous ayez besoin d'analystes de sécurité, d'ingénieurs de sécurité ou de consultants, Talentive est ici pour vous mettre en relation avec les meilleurs talents en matière de cybersécurité . La cybersécurité est une priorité pour nous chez Talentive !",
      content_en: "Cybersecurity is more important than ever in today's digital landscape. We help you recruit specialists who can protect your systems and data. Whether you need security analysts, security engineers, or consultants, Talentive is here to connect you with the best cybersecurity talents. Cybersecurity is a priority for us at Talentive!"
    }
  }

  const categoryColors = {
    1: 'blue',
    2: 'indigo',
    3: 'violet', 
    4: 'purple', 
    5: 'fuchsia',
    6: 'pink'
  }




  return (
    <div>

            {/* <div className="py-3 my-4 space-x-2 whitespace-nowrap max-w-1/2 overflow-x-hidden overscroll-x-contain no-scrollbar text-2xl font-montserrat font-base "> */}
            {/* <div className=" py-3 my-4 space-x-2 overflow-x-hidden no-scrollbar text-2xl font-montserrat font-base"> */}


            <div className="flex items-center space-x-1">
  {/* Left Scroll Button */}
  <div className={`${selectedSpecializationId < 2 ? 'hidden' : 'inline '} pr-1 cursor-pointer`} onClick={() => {
    if (selectedSpecializationId < 2) {
      return false
    }
      scrollLeft()
      setSelectedSpecializationId(selectedSpecializationId -1)
    }}>
    <i className="text-3xl text-gray-600 dark:text-gray-500 dark:hover:text-gray-400 duration-300 fa-solid fa-circle-chevron-left"></i>
  </div>

  {/* Pill Button Container */}
  <div
    id="pillButtonContainer"
    className="relative rounded-3xl font-montserrat text-center whitespace-nowrap space-x-2 py-3 mx-auto overflow-x-auto overscroll-x-contain no-scrollbar flex-1"
  >
    <PillButton

      callback={handlePillButtonCallback}
      selectedId={selectedSpecializationId}
      data={{
        id: 1,
        caption:
          lang === 'fr'
            ? 'Développement et Ingénierie Logicielle'
            : 'Software Development & Engineering',
      }}
      colors={{ background: 'inherit', border: 'blue', text: 'blue' }}
    />
    <PillButton

      callback={handlePillButtonCallback}
      selectedId={selectedSpecializationId}
      data={{
        id: 2,
        caption:
          lang === 'fr'
            ? 'Opérations TI et Infrastructure'
            : 'IT Operations & Infrastructure',
      }}
      colors={{ background: 'inherit', border: 'indigo', text: 'indigo' }}
    />
<PillButton 
                        callback={handlePillButtonCallback}
                        selectedId={selectedSpecializationId}
              lang={'lang'} 
              data={{id:3, caption: lang === 'fr' ? 'Analyse des Affaires et Systèmes' : 'Business & Systems Analysis'}}
              colors={{background: 'inherit', border:'violet', text:'violet' }}
            />
            <PillButton 
                        callback={handlePillButtonCallback}
                        selectedId={selectedSpecializationId}
              lang={'lang'} 
              data={{id:4, caption: lang === 'fr' ? 'Données et Analyse' : 'Data & Analytics'}}
              colors={{background: 'inherit', border:'purple', text:'purple' }}
            />

            <PillButton 
                        callback={handlePillButtonCallback}
                        selectedId={selectedSpecializationId}
              lang={'lang'} 
              data={{id:5, caption: lang === 'fr' ? 'Infonuagique et Virtualisation' : 'Cloud & Virtualization'}}
              colors={{background: 'inherit', border:'fuchsia', text:'fuchsia' }}
            />
            <PillButton 
                        callback={handlePillButtonCallback}
                        selectedId={selectedSpecializationId}
              lang={'lang'} 
              data={{id:6, caption: lang === 'fr' ? 'Cybersécurité' : 'Cybersecurity'}}
              colors={{background: 'inherit', border:'pink', text:'pink' }}
            />
  </div>

  {/* Right Scroll Button */}
  <div className={`${selectedSpecializationId > 5 ? 'hidden' : 'inline '} pl-1 cursor-pointer`} onClick={() => {
    if (selectedSpecializationId > 5) { 
      return false
    }
      scrollRight()
      setSelectedSpecializationId(selectedSpecializationId + 1)
    }}>
 <i className="text-3xl fa-solid text-gray-600 dark:text-gray-500 dark:hover:text-gray-400 duration-300 fa-circle-chevron-right"></i>
  </div>
</div>












{/* 
            <div id='pillButtonContainer' className="relative table font-montserrat text-center whitespace-nowrap space-x-2 py-3 mx-auto overflow-x-auto overscroll-x-contain no-scrollbar">


            <PillButton 
            callback={handlePillButtonCallback}
            selectedId={selectedSpecializationId}
              data={{id:1, caption: lang === 'fr' ? 'Développement et Ingénierie Logicielle' : 'Software Development & Engineering'}}
              colors={{background: 'inherit', border:'blue', text:'blue' }}
            />
            <PillButton 
                        callback={handlePillButtonCallback}
                        selectedId={selectedSpecializationId}
              lang={'lang'} 
              data={{id:2, caption: lang === 'fr' ? 'Opérations TI et Infrastructure' : 'IT Operations & Infrastructure'}}
              colors={{background: 'inherit', border:'indigo', text:'indigo' }}
            />
            <PillButton 
                        callback={handlePillButtonCallback}
                        selectedId={selectedSpecializationId}
              lang={'lang'} 
              data={{id:3, caption: lang === 'fr' ? 'Analyse des Affaires et Systèmes' : 'Business & Systems Analysis'}}
              colors={{background: 'inherit', border:'violet', text:'violet' }}
            />
            <PillButton 
                        callback={handlePillButtonCallback}
                        selectedId={selectedSpecializationId}
              lang={'lang'} 
              data={{id:4, caption: lang === 'fr' ? 'Données et Analyse' : 'Data & Analytics'}}
              colors={{background: 'inherit', border:'purple', text:'purple' }}
            />

            <PillButton 
                        callback={handlePillButtonCallback}
                        selectedId={selectedSpecializationId}
              lang={'lang'} 
              data={{id:5, caption: lang === 'fr' ? 'Infonuagique et Virtualisation' : 'Cloud & Virtualization'}}
              colors={{background: 'inherit', border:'fuchsia', text:'fuchsia' }}
            />
            <PillButton 
                        callback={handlePillButtonCallback}
                        selectedId={selectedSpecializationId}
              lang={'lang'} 
              data={{id:6, caption: lang === 'fr' ? 'Cybersécurité' : 'Cybersecurity'}}
              colors={{background: 'inherit', border:'pink', text:'pink' }}
            />
       
      </div> */}
      



<div>
<div className={`pt-2 min-h-96 text-black dark:text-gray-300 text-base font-inter`}>
          {/* {textBody} */}
          
          {showIntro && <div className={`mb-4 mt-6 text-base font-base text-base font-inter mx-8 text-left border-l-4 pl-4

              ${borderColorVariants[selectedSpecializationColors]}`}
            >
          {/* {specializationIntros[selectedSpecializationId].content_fr} */}
          {specializationIntros[selectedSpecializationId][lang === 'fr' ? 'content_fr' : 'content_en']}
          </div>}
          <br/>

        
          {/* <div className={`flex flex-wrap gap-4 justify-center lg:justify-start`}>
       
            {specializations.map(x => 
              <SpecializationChildCard  
              textCaption={lang === 'fr' ? x.caption_fr : x.caption_en} 
              show={selectedSpecializationId === x.category_id && true} 
              colors={{
                border: categoryColors[x.category_id], 
                background:'', 
                caption: categoryColors[x.category_id]
              }}
              />
            )}
    
          </div> */}


<div className={`flex flex-wrap gap-3 justify-center lg:justify-start`}>
    {specializations.map(x => (
        // selectedSpecializationId === x.category_id && (
            <SpecializationChildCard
                key={x.caption_en}
                textCaption={lang === 'fr' ? x.caption_fr : x.caption_en}
                colors={{
                    border: categoryColors[x.category_id],
                    background: '',
                    caption: categoryColors[x.category_id]
                }}
                show={x.category_id === selectedSpecializationId}
            />
        // )
    ))}
</div>
{/* 
          <div className="flex lg:grid-cols-1 gap-2 mx-auto container mb-36 px-4 ">
          <div className="lg:col-span-1 w-full">

            </div>
            </div> */}
        </div>
</div>

      
    {/* <div className={`mt-4 pb-12 rounded-3xl flex flex-col min-h-96 ${colorVariants[colors.background]} border-2 ${selectedSpecializationColors && borderColorVariants[selectedSpecializationColors]}`}>

      <div className="relative flex-1">

   
        <h2 className={`${textColorVariants[selectedSpecializationColors]} text-xl absolute top-0 left-0 w-full text-center`} style={{ padding: '20px 0'}}>
          <strong style={{ fontFamily: 'Montserrat', fontWeight: '600' }}>
            {lang === 'fr' ? "Nos métiers en " : "Our roles in "} {selectedSpecializationCategoryName} {lang === 'fr' ? 'sont' : 'are'}
          </strong> 
        </h2>
      <br/>
        {textURL && <div className='text-center text-black dark:text-gray-400'><a target="_blank" className='hover:text-gray-500 duration-300' href={"https://"+textURL}>{textURL}</a></div>}
        <div className={`pt-2 px-8 overflow-y-auto h-full text-black dark:text-gray-300 text-base font-inter`}>
          {textBody}
          {selectedSpecializationId === 1 && <>
            Whether you need highly skilled engineers to test and deploy software or developers to build applications from the user interface to the server-side, Talentive is here to help you find the right talent in Canada. We specialize in connecting businesses with top-tier professionals who can design, develop, and maintain high-quality software solutions tailored to your specific needs.<br/><br/>  

Here are some of the software development and engineering positions we recruit for:</>}

          <div className="flex lg:grid-cols-1 gap-2 mx-auto container mb-36 px-4 ">
          <div className="lg:col-span-1 w-full">

            </div></div>
        </div>
      </div>
    </div> */}
</div>

  );
}

export default SpecializationsParentCard;